import { render, staticRenderFns } from "./TypeRadioControl.vue?vue&type=template&id=34bbbaef&scoped=true&"
import script from "./TypeRadioControl.vue?vue&type=script&lang=js&"
export * from "./TypeRadioControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbbaef",
  null
  
)

export default component.exports